import Breakpoints from '@/constants/breakpoints';

const isMobile = window.matchMedia(`(max-width: ${Breakpoints.md}px)`);
export const isLessThanLg = window.matchMedia(`(max-width: ${Breakpoints.lg}px)`);

export default isMobile;
